import { getEnvVar } from '@utils/environmentVariables';

import { getLocalFeatureFlag } from './featureFlags';

const shouldUseLocalhostRedirectUrl =
  process.env.NODE_ENV === 'development' || getLocalFeatureFlag('forceLocalhostRedirectUrl');

const redirectSignInUrl = shouldUseLocalhostRedirectUrl
  ? 'http://localhost:3000/task-management'
  : process.env.NEXT_PUBLIC_REDIRECT_SIGN_IN;

const redirectSignOutUrl = shouldUseLocalhostRedirectUrl
  ? 'http://localhost:3000/task-management'
  : getEnvVar('NEXT_PUBLIC_REDIRECT_SIGN_OUT');

export interface ICognitoStorage {
  setItem(key: string, value: string): void;
  getItem(key: string): string | null;
  removeItem(key: string): void;
  clear(): void;
}

export const electronStorage: ICognitoStorage = {
  setItem: (key: string, value: string) => window.electronAPI?.setAuthItem(key, value),
  getItem: (key: string) => window.electronAPI!.getAuthItem(key),
  removeItem: (key: string) => window.electronAPI?.removeAuthItem(key),
  clear: () => window.electronAPI?.clearAuthItems(),
};

export const authConfig = {
  Auth: {
    mandatorySignIn: true,
    region: process.env.NEXT_PUBLIC_REGION,
    userPoolId: process.env.NEXT_PUBLIC_USER_POOL_ID,
    userPoolWebClientId:
      typeof window !== 'undefined' && window.electronAPI
        ? process.env.NEXT_PUBLIC_COUNTER_TERMINAL_USER_POOL_WEB_CLIENT_ID //steal from ct and also set it in environment variables.ts
        : process.env.NEXT_PUBLIC_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.NEXT_PUBLIC_DOMAIN,
      scope: ['openid', 'profile'],
      redirectSignIn: redirectSignInUrl,
      redirectSignOut: redirectSignOutUrl,
      responseType: 'code',
    },
    // If on CT use the storage functions provided on the electron bridge. Otherwise just keep the default behavior
    storage: typeof window !== 'undefined' && window.electronAPI ? electronStorage : undefined,
  },
  Storage: {
    AWSS3: {
      bucket: getEnvVar('NEXT_PUBLIC_S3_BUCKET'), //REQUIRED -  Amazon S3 bucket name
    },
  },
};
